module.exports = __webpack_public_path__ + "img/logo-black.913bcfa8.png";